import { Component, OnInit, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { DirectivesModule } from 'src/app/directives.module';

@Component({
  selector: 'app-profile-validated-dict',
  standalone: true,
  imports: [NgClass, DirectivesModule],
  templateUrl: './profile-validated-dict.component.html',
  styleUrl: './profile-validated-dict.component.scss'
})
export class ProfileValidatedDictComponent {
  @Input() validateDict: any;
  @Input() from: any;
  constructor() { }

  ngOnInit(): void {
  }

}
